// @flow
import React from "react";
import { useSelector } from "react-redux";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
  SelecaoAtivoSemRisco,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { VALOR_DEFAULT_BENCHMARK_QUANTITATIVA } from "../../../model";

export const processarPeriodoComAtivoSemRisco = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        ativoSemRisco:
          edicaoMedida.ativoSemRisco || VALOR_DEFAULT_BENCHMARK_QUANTITATIVA,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        ativoSemRisco: edicaoMedida.ativoSemRisco,
        dataBase: dataBase,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoComAtivoSemRisco = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoAtivoSemRisco />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida">
            <SelecaoAtivoSemRisco />
          </div>
          <SelecaoCasasDecimais />
        </div>
        <div className="ConfiguracaoMedida__horizontal-divider" />
        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida--flex">
            <SelecaoPeriodo exibirPeriodicidade={false} />
          </div>

          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>

            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PeriodoComAtivoSemRisco;
